import { useQuery, QueryKey as QueryKeyType } from '@tanstack/react-query';
import { QueryKey } from 'utils/constants/query-keys.enum';
import { useConnection, useChainId } from 'wagmi';
import { usePublicClient } from 'wagmi';
import { ETH_AVERAGE_BLOCK_TIME } from 'utils/constants/ethConst';

type UseChainBlockParams = {
  queryKey?: QueryKeyType;
  watch?: boolean;
};

export const useChainBlock = (params?: UseChainBlockParams) => {
  const account = useConnection();
  const chainId = useChainId();

  const {
    queryKey = [QueryKey.CHAIN_BLOCK, account?.address || '', chainId],
    watch = true,
  } = params || {};
  const publicClient = usePublicClient({ chainId });

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      if (!publicClient) {
        throw new Error('No public client available');
      }

      const block = await publicClient.getBlock();
      return {
        timestamp: Number(block.timestamp) * 1000,
        number: Number(block.number),
      };
    },
    initialData: { number: 0, timestamp: Date.now() },
    refetchInterval: watch ? ETH_AVERAGE_BLOCK_TIME : false,
  });
};
